





















import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {IMenuEntity} from "@/model/menu/IMenuEntity";
import {IMenuBaseEntity} from "@/model/menu/IMenuBaseEntity";
import {IMenuSubEntity} from "@/model/menu/IMenuSubEntity";

@Component
export default class BaseSideMenuEntity extends Vue {
    @Prop() menu!: IMenuEntity;
    @Prop() private collapseState!: any;

    toggleCollapse(menu: IMenuEntity) {
        const value = this.collapseState[menu.name];
        if ( typeof this.collapseState[menu.name] === 'undefined' )
            this.collapseState[menu.name] = false;
        else
            this.collapseState[menu.name] = !value;
    }

    getCollapseState(menu: IMenuEntity): boolean {
        const value = this.collapseState[menu.name];
        if ( typeof value === "undefined" ) return true;

        return value;
    }

    isRouteActive(eachMenu: IMenuEntity): boolean {
        const isItself = eachMenu.name === this.$route.name;
        const isInSubMenus = this.isSubMenuRouteActive(eachMenu);
        const isInRoutes = eachMenu.routes && eachMenu.routes.some( (eachSubMenu) => eachSubMenu.name === this.$route.name );
        return isItself || isInSubMenus || isInRoutes;
    }

    isSubMenuRouteActive(eachMenu: IMenuBaseEntity): boolean {
        if ( !eachMenu.subMenus || eachMenu.subMenus.length === 0 ) return false;

        return eachMenu.subMenus && eachMenu.subMenus.some( (eachSubMenu) => {
            if ( eachSubMenu.name === this.$route.name )
                return true;

            return this.isSubMenuRouteActive(eachSubMenu);
        } );
    }

    @Emit()
    onMenuClose() {
        return;
    }
}
